import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { templatesApi, documentsApi } from '../api/index.js';
import { useAuth } from '../hooks/useAuth.js';

export function DashboardPage() {
  const { user } = useAuth();
  const { data: tplData } = useQuery({ queryKey: ['templates'], queryFn: () => templatesApi.list() });
  const { data: docData } = useQuery({ queryKey: ['documents', 'recent'], queryFn: () => documentsApi.list({ limit: '5' }) });

  const templates = tplData?.templates ?? [];
  const docs = docData?.documents ?? [];
  const total = docData?.total ?? 0;

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '1.5rem' }}>Dashboard</h1>
      <p style={{ color: 'var(--color-text-muted)', marginBottom: '2rem' }}>
        Welcome back, <strong>{user?.username}</strong>
      </p>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: '1rem', marginBottom: '2rem' }}>
        <StatCard label="Active Templates" value={templates.length} />
        <StatCard label="Total Documents" value={total} />
      </div>

      {/* Recent documents */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h2 style={{ fontSize: '1rem', fontWeight: 600 }}>Recent Documents</h2>
          <Link to="/documents" style={{ fontSize: '.875rem' }}>View all →</Link>
        </div>
        {docs.length === 0 ? (
          <p style={{ color: 'var(--color-text-muted)', fontSize: '.875rem' }}>No documents yet.</p>
        ) : (
          <table>
            <thead>
              <tr><th>File</th><th>Source</th><th>Status</th><th>Created</th></tr>
            </thead>
            <tbody>
              {docs.map((d) => (
                <tr key={d.id}>
                  <td><Link to={`/documents/${d.id}`}>{d.fileName}</Link></td>
                  <td><span className={`badge ${d.source === 'mcp' ? 'badge-green' : 'badge-gray'}`}>{d.source}</span></td>
                  <td><StatusBadge status={d.status} /></td>
                  <td style={{ color: 'var(--color-text-muted)' }}>{new Date(d.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="card" style={{ textAlign: 'center' }}>
      <div style={{ fontSize: '2rem', fontWeight: 700 }}>{value}</div>
      <div style={{ fontSize: '.875rem', color: 'var(--color-text-muted)' }}>{label}</div>
    </div>
  );
}

function StatusBadge({ status }: { status: string }) {
  const cls = status === 'completed' ? 'badge-green' : status === 'failed' ? 'badge-red' : 'badge-yellow';
  return <span className={`badge ${cls}`}>{status}</span>;
}
